import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { WorkOrderContext } from '../context/WorkOrderContext';

export default function CustomerInformationPanel() {

	const { order } = useContext(WorkOrderContext);

	return (
		<>
			<Panel
				header={'Customer Information'}
				className="field-label-30"
			>
				<Field label={'Name'} >{order.details.customerName}</Field>
				<Field label={'Address'} >{order.details.customerAddress1}</Field>
				<Field label={''} visible={!!order.details.customerAddress2}>{order.details.customerAddress2}</Field>
				<Field label={''} >{order.details.customerCityZip}</Field>
				<Field label={'Phone'} >{order.details.customerPhone}</Field>
				<Field label={'Alt. Phone'} >{order.details.customerAlternatePhone}</Field>
				<Field label={'Email'} > <a href={'mailto:' + order.details.customerEmail}>{order.details.customerEmail}</a></Field>
			</Panel>
		</>
	);
}
